import React from 'react';
import {observer} from 'mobx-react';
import {StandingsWidgetGroup} from "../group/standings-widget.group";
import {StandingsWidgetGroupedRowsViewModel} from "../../models/standings-widget.grouped-rows-view-model";
import {StandingsWidgetTableContent} from "./standings-widget.table-content";
import {StandingsWidgetController} from "../../standings-widget.controller";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";

export class StandingsWidgetTableStandingsGroupsProps extends BaseProps {
  controller: StandingsWidgetController;
  isPreviewStandings: Boolean;
  source: String;
}

export const StandingsWidgetTableStandingsGroups = observer(({
                                                               controller,
                                                               isPreviewStandings,
                                                               source
                                                             }: StandingsWidgetTableStandingsGroupsProps) => {
  const {state} = controller;
  const {hasGroups, groups, headers} = state;

  const contentProps = {
    controller,
    source,
    shouldRenderTable: true
  }

  const groupsBodyProps = {
    controller,
    isPreviewStandings,
  }

  return hasGroups ? groups?.map((group: StandingsWidgetGroupedRowsViewModel) =>
    <StandingsWidgetGroup group={group} key={group.num} {...groupsBodyProps}>
      <StandingsWidgetTableContent rows={isPreviewStandings ? group.previewStandingsRows : group.rows} headers={headers}
        key={group.num}
        num={group.num}
        isGroup
        {...contentProps}
      />
    </StandingsWidgetGroup>
  ) : null
});
